import { FC, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";

import __ from "web/Layout/Translations";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { pageName } from "web/constants/toolbar";

import { getCodes } from "web/features/codes/codesThunks";
import { FilterValues } from "web/features/codes/utils/helpers";

import classes from "./filters.scss";

interface ICustomerCodeListFiltersMobileProps {
  filters: { label: string; value: string; count: number }[];
  name: string;
  closeModal: () => void;
}

const CustomerCodeListFiltersMobile: FC<
  ICustomerCodeListFiltersMobileProps
> = ({ name, filters, closeModal }) => {
  const { search, pathname } = useLocation();
  const { push } = useHistory();
  const dispatch = useDispatch();
  const type = new URLSearchParams(search).get(name) || FilterValues.ALL;

  const handleFilterChange = useCallback(
    (filterValue: FilterValues) => {
      if (filterValue === type) {
        return;
      }

      const params = new URLSearchParams(search);
      params.delete(pageName);
      params.set(name, filterValue);
      push(`${pathname}?${params.toString()}`);
      dispatch(getCodes({ page: 1, filterValue }));
      closeModal();
    },
    [type, search, pathname, push, dispatch, name, closeModal]
  );

  return isArrayHasItems(filters) ? (
    <div className={classes.root}>
      <h2 className={classes.filtersHeader}>{__("Filtry")}</h2>
      <div className={classes.form}>
        <h3 className={classes.filtersSecondHeader}>{__("Wyświetl kody")}</h3>
        {filters.map(({ label, value }) => (
          <div
            className={classes.item}
            key={value}
            data-t1="code_list_filters_item"
            data-t2={label}
          >
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className={classes.label}>
              <input
                className="visually-hidden"
                type="radio"
                name={name}
                value={value}
                checked={type === value}
                onChange={() => handleFilterChange(value as FilterValues)}
                data-t1={`${value}_field`}
              />
              <span className={classes.option}>
                <span className={classes.radio} aria-hidden="true" />
                <span className={classes.text} data-t1={`${value}_label`}>
                  {label}
                </span>
              </span>
            </label>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default CustomerCodeListFiltersMobile;
